import {HTTP} from "@/helpers/http-common"

const urlModule = 'bitacorascheduler'

const get = (seguimientoControl) => new Promise((resolve,reject)=>{
  HTTP.post(
    `/api/${urlModule}/getDataChartBitacora`
    , seguimientoControl
  ).then(response=>{
    resolve(response);
  }).catch(error => {
    reject(error);
  });

});

const post = (ejecucion) => new Promise((resolve,reject)=>{
  HTTP.post(
    `/api/${urlModule}/ejecucionExtemporanea`
    , ejecucion
  ).then(response=>{
    resolve(response);
  }).catch(error => {
    reject(error);
  });

});

const getLog = (proceso) => new Promise((resolve,reject)=>{
  HTTP.get(
    `/api/${urlModule}/getLog/${proceso}`
  ).then(response=>{
    resolve(response);
  }).catch(error => {
    reject(error);
  });

});

  export default{
    get
    , post
    , getLog
  }



// WEBPACK FOOTER //
// ./src/services/seguimiento/scheduled/index.js